import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const ForgotPassword = loadable(() => import(/* webpackChunkName: "ForgotPassword" */ './ForgotPassword'), {
  fallback: <LoadableFallback visible />,
});

const asyncForgotPassword = ({ route }) => (
  <ForgotPassword route={route} />
);

asyncForgotPassword.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncForgotPassword;
